import { RangeInput } from 'shared/components/RangeInput';
import styles from './DropdownBedrooms.css';
import { FC } from 'react';

interface IDropdownBedroomsProps {
  valueMin: number | null;
  valueMax: number | null;

  onMinChange(gte: number | null): void;
  onMaxChange(lte: number | null): void;
}

export const DropdownBedrooms: FC<IDropdownBedroomsProps> = ({ valueMin, valueMax, onMinChange, onMaxChange }) => {
  return (
    <div className={styles['dropdown']}>
      <RangeInput
        min={0}
        max={50}
        joined={false}
        valueMin={valueMin}
        valueMax={valueMax}
        onChangeMin={onMinChange}
        onChangeMax={onMaxChange}
      />
    </div>
  );
};
